import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  svgStyles?: string
}

const PasswordSvg = (props: Props): JSX.Element => {
  const { svgStyles, ...rest } = props

  const img = `
  <svg version="1.0" ${props.svgStyles ?? ''} xmlns="http://www.w3.org/2000/svg"
    width="100%" height="100%" viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
    fill="currentColor" stroke="none">
    <path d="M1120 3939 c-28 -8 -132 -107 -503 -482 -486 -490 -528 -537 -583
    -672 -26 -63 -29 -84 -32 -210 -4 -166 8 -228 71 -350 38 -76 66 -105 511
    -553 259 -260 485 -482 503 -493 17 -11 54 -22 82 -26 106 -12 206 71 219 182
    10 91 -6 110 -502 603 -418 416 -456 456 -475 507 -27 71 -27 129 0 202 20 54
    52 89 484 523 393 395 465 472 480 512 58 155 -87 302 -255 257z"/>
    <path d="M3822 3925 c-91 -47 -132 -149 -97 -243 15 -40 87 -117 480 -512 432
    -434 464 -469 484 -523 27 -73 27 -131 0 -202 -19 -51 -57 -91 -475 -507 -496
    -493 -512 -512 -502 -603 13 -111 113 -194 219 -182 28 4 65 15 82 26 18 11
    244 233 503 493 l471 473 46 95 c111 228 100 464 -32 672 -41 64 -930 974
    -986 1008 -19 12 -58 24 -87 26 -44 5 -62 1 -106 -21z"/>
    <path d="M1696 2743 c-46 -13 -96 -57 -121 -106 -32 -66 -32 -112 3 -178 22
    -43 38 -59 81 -81 66 -35 112 -35 178 -3 75 38 108 91 108 175 0 77 -25 127
    -85 166 -38 25 -123 39 -164 27z"/>
    <path d="M2489 2741 c-43 -14 -76 -40 -105 -84 -24 -35 -29 -52 -29 -107 0
    -84 33 -137 108 -175 64 -32 110 -32 174 0 75 38 108 91 108 175 0 55 -5 72
    -29 108 -16 23 -44 51 -62 63 -37 23 -124 33 -165 20z"/>
    <path d="M3282 2739 c-18 -5 -50 -27 -72 -49 -96 -96 -70 -253 53 -315 66 -32
    112 -32 178 3 43 22 59 38 81 81 35 66 35 112 3 178 -44 88 -147 132 -243 102z"/>
    </g>
  </svg>
  `
  return <div {...rest} dangerouslySetInnerHTML={{ __html: img }} />
}

export default PasswordSvg
